import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSpinner, faCheck, faExclamationTriangle, faMusic, faVideo, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import './JobStatus.css';

const JobStatus = ({ jobs, onCancelJob, isConnected }) => {
  if (!jobs || jobs.length === 0) return null;

  const getJobIcon = (queue) => {
    switch (queue) {
      case 'audio':
        return faMusic;
      case 'video': 
        return faVideo;
      case 'document':
        return faFileAlt;
      default:
        return faFileAlt;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'queued':
        return '#6c757d';
      case 'active':
        return '#007bff';
      case 'completed':
        return '#28a745';
      case 'failed':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'queued':
      case 'active':
        return faSpinner;
      case 'completed':
        return faCheck;
      case 'failed':
        return faExclamationTriangle;
      default:
        return faSpinner;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'queued':
        return 'В очереди';
      case 'active':
        return 'Обрабатывается';
      case 'completed':
        return 'Завершено';
      case 'failed':
        return 'Ошибка';
      default:
        return 'Неизвестно';
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    const k = 1024;
    const sizes = ['Байт', 'КБ', 'МБ', 'ГБ'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleCancelJob = (job) => {
    if (onCancelJob && (job.status === 'queued' || job.status === 'active')) {
      onCancelJob(job.jobId, job.queue);
    }
  };

  return (
    <div className="job-status-container">
      <div className="job-status-header">
        <h6 className="mb-0">
          Обработка файлов
          {!isConnected && (
            <span className="text-warning ms-2" title="Нет соединения с сервером">
              ⚠️
            </span>
          )}
        </h6>
      </div>
      
      <div className="job-status-list">
        {jobs.map((job) => (
          <div key={`${job.queue}-${job.jobId}`} className="job-status-item">
            <div className="job-header">
              <div className="job-info">
                <FontAwesomeIcon 
                  icon={getJobIcon(job.queue)} 
                  className="job-type-icon"
                />
                <div className="job-details">
                  <div className="job-filename" title={job.fileName}>
                    {job.fileName}
                  </div>
                  {job.fileSize && (
                    <div className="job-filesize">
                      {formatFileSize(job.fileSize)}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="job-actions">
                <div className="job-status">
                  <FontAwesomeIcon 
                    icon={getStatusIcon(job.status)}
                    style={{ color: getStatusColor(job.status) }}
                    className={job.status === 'active' || job.status === 'queued' ? 'fa-spin' : ''}
                  />
                  <span className="status-text" style={{ color: getStatusColor(job.status) }}>
                    {getStatusText(job.status)}
                  </span>
                </div>
                
                {(job.status === 'queued' || job.status === 'active') && (
                  <button
                    className="btn btn-sm btn-outline-danger cancel-btn"
                    onClick={() => handleCancelJob(job)}
                    title="Отменить обработку"
                    disabled={!isConnected}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}
              </div>
            </div>
            
            {(job.status === 'active' && job.progress !== undefined) && (
              <div className="job-progress">
                <div className="progress">
                  <div 
                    className="progress-bar"
                    style={{ width: `${job.progress}%` }}
                    role="progressbar"
                    aria-valuenow={job.progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {job.progress > 0 && `${job.progress}%`}
                  </div>
                </div>
                {job.stage && (
                  <div className="job-stage" style={{ marginTop: '4px', textAlign: 'center' }}>
                    <small>{job.stage}</small>
                  </div>
                )}
              </div>
            )}
            
            {job.status === 'failed' && job.error && (
              <div className="job-error">
                <small className="text-danger">
                  Ошибка: {job.error}
                </small>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobStatus; 